// gloss
export const normalizeDomain = (domainOrUrl: string | null | undefined): string => {
  if (!domainOrUrl || typeof domainOrUrl !== 'string') return '';
  let cleaned = domainOrUrl.trim();
  cleaned = cleaned.replace(/^https?:\/\//i, '');
  cleaned = cleaned.replace(/^www\./i, '');
  cleaned = cleaned.split(/[/?#]/)[0] ?? '';
  return cleaned;
};

// gloss
export const inferCompanyNameFromDomain = (domain: string | null | undefined): string | null => {
  const normalized = normalizeDomain(domain);
  if (!normalized) return null;
  const firstLabel = normalized.split('.')[0];
  if (!firstLabel) return null;
  return firstLabel.charAt(0).toUpperCase() + firstLabel.slice(1);
};

// gloss
const FREE_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
  'aol.com',
  'att.net',
  'charter.net',
  'comcast.net',
  'cox.net',
  'gmail.com',
  'gmx.com',
  'gmx.net',
  'googlemail.com',
  'hotmail.com',
  'icloud.com',
  'live.com',
  'mac.com',
  'mail.com',
  'me.com',
  'msn.com',
  'outlook.com',
  'proton.me',
  'protonmail.com',
  'sbcglobal.net',
  'verizon.net',
  'yahoo.com',
  'yandex.com',
  'ymail.com',
  'zoho.com',
]);

// gloss
export const isFreeEmailDomain = (domain: string | null | undefined): boolean => {
  const normalized = normalizeDomain(domain).toLowerCase();
  return normalized !== '' && FREE_EMAIL_DOMAINS.has(normalized);
};

// gloss
export const accountDomainFromEmail = (email: string | null | undefined): string | null => {
  if (!email || typeof email !== 'string') return null;
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain || isFreeEmailDomain(domain)) return null;
  return domain;
};
